// @ts-nocheck
import { RootStoreType } from './RootStore';
import { flow, getRoot, Instance, SnapshotIn, types } from 'mobx-state-tree';
import { getBaseStore } from './BaseStore';
import { getEnvironment } from './utils/utils';
import { DutyAssignment } from './models/DutyAssignment';
import NotificationToast from '../components/common/NotificationToast';
import moment from 'moment';

export interface DutyAssignmentSearchCriteria {
  pharmacyApbNumberOrName?: string;
  pharmacyAddress?: string;
  startDate?: string;
  endDate?: string;
  date?: string;
  year?: string;
  pharmacyIdForNeighbor?: number;
  notAssigned?: boolean;
  publishedOnly?: boolean;
  planningId?: number;
  pharmacyId?: number;
  dutyAssignmentId?: number;
  type?: string;
}

export const DutyAssignmentStore = types
  .compose(
    getBaseStore<Instance<typeof DutyAssignment>, SnapshotIn<typeof DutyAssignment>>(
      DutyAssignment,
      'dutyAssignmentId',
      'dutyAssignment',
    ),
    types.model('DutyAssignmentStore', {}),
  )
  .views((self) => ({
    getDutiesByType(pharmacyId: number, nightDuty: boolean) {
      if (pharmacyId > 0) {
        // const dutiesGrid = self.datas.forEach(da => {return da}); //.pharmacyId==pharmacyId && da.Duty.nightDuty == nightDuty)
        return self.datas;
      } else {
        return new Array();
      }
    },
  }))
  .actions((self) => {
    const env = getEnvironment(self);
    const root: RootStoreType = getRoot(self);
    const apiFetcher = env.api;

    const assignDuty = flow(function*(data: any) {
      try {
        const result = yield env.api.post('dutyAssignment/Assign', data);
        if (result !== '' && result != null) {
          Array.from(result).map((item) => self.datas.put(item));
          NotificationToast.showSuccess('Duty assigned successfully');
        } else {
          NotificationToast.showError('Duty already assigned for this day and type');
        }
        return result;
      } catch (error) {
        console.log('error', error);
        NotificationToast.showError(
          // @ts-ignore
          error.error.errorMessage ? error.error.errorMessage : 'No DutyAssignment available for this date/type',
        );
        return null;
      }
    });

    const unassignDuty = flow(function*(data: any) {
      console.log(data);
      const result = yield env.api.post('dutyAssignment/Unassign/' + data, null);
      if (result != null) {
        NotificationToast.showSuccess('Duty unassigned successfully');
      } else {
        // NotificationToast.showError(
        //   error.error.errorMessage ? error.error.errorMessage : 'No DutyAssignment available for this date/type',
        // );
      }
    });

    const dutyRosterReport = flow(function*(criteria: any, onSuccess?: () => void, onError?: () => void) {
      apiFetcher.downloadFile(
        'report/DutyRoster',
        {
          params: criteria,
        },
        'pdf',
        'ListeDesGardes-du-' +
          moment(criteria.startDate).format('DD-MM-YYYY') +
          '-au-' +
          moment(criteria.endDate).format('DD-MM-YYYY'),
        onSuccess,
        onError,
      );
    });

    const searchAssignment = flow(function*(criteria: DutyAssignmentSearchCriteria) {
      const result = yield apiFetcher.get('dutyAssignment', {
        params: criteria,
      });
      // @ts-ignore
      self.putInStore(result);
      // @ts-ignore
      const resultIds = result.map((r) => r.dutyAssignmentId);
      return self.dataList.filter((d) => resultIds.indexOf(d.dutyAssignmentId) >= 0);
    });

    const searchAssignmentByPharmacyId = flow(function*(pharmacyId: number) {
      // const results = self.dataList.filter((d) => d.pharmacyId == pharmacyId);
      // if (results.length > 0) {
      //   return results;
      // }
      const result = yield apiFetcher.get('dutyAssignment', {
        params: { pharmacyId: pharmacyId },
      });

      // @ts-ignore
      self.putInStore(result);
      // @ts-ignore
      const resultIds = result.map((r) => r.dutyAssignmentId);
      return self.dataList.filter((d) => resultIds.indexOf(d.dutyAssignmentId) >= 0);
    });

    const downloadLatestAdditions = flow(function*() {
      const result = yield env.api.get('DutyAssignment/downloadAdditionsForWebGarde', {
        responseType: 'blob',
      });
      if (result != null) {
        if ((result as Blob).size > 37) {
          const url = window.URL.createObjectURL(new Blob([result]));
          const link = document.createElement('a');
          link.href = url;
          link.setAttribute('download', 'PharmagardeToWebGardeAddedDuties-' + new Date().toISOString() + '.csv'); //or any other extension
          document.body.appendChild(link);
          link.click();
          return false;
        } else {
          return true;
        }
      } else {
        return true;
      }
    });

    const sendLatestAdditions = flow(function*() {
      const result = yield env.api.get('DutyAssignment/generateAdditionsForWebGarde', {
        responseType: 'blob',
      });
      if (result != null) {
        // const url = window.URL.createObjectURL(new Blob([result]));
        // const link = document.createElement('a');
        // link.href = url;
        // link.setAttribute('download', 'PharmagardeToWebGardeAddedDuties.csv'); //or any other extension
        // document.body.appendChild(link);
        // link.click();
        NotificationToast.showSuccess('success');
      }
    });

    return {
      assignDuty,
      unassignDuty,
      dutyRosterReport,
      searchAssignment,
      searchAssignmentByPharmacyId,
      downloadLatestAdditions,
      sendLatestAdditions,
    };
  });
